export default __webpack_public_path__ + "static/Agrandir-Bold-89ac5f1470143bf26b1caf7762f41d65.woff2";